import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "../Miltis/AdherenBirthdate";
import AdherentInfo from "../Miltis/AdherentInfo";
import AdherentTelecoms from "../Miltis/AdherentTelecoms";
import BankInformation from "../Miltis/BankInformation";
import ChildrenJustification from "../Miltis/ChildrenJustification";
import Loading from "../Miltis/Components/Loader";
import Default from "../Miltis/Default";
import EffectiveDate from "../Miltis/EffectiveDateTer";
import ElectronicSignature from "../Miltis/ESign";
import GenerateESignDocuments from "../Miltis/GenerateESignDocuments";
import Justification from "../Miltis/JustificationTer";
import Needs from "../Miltis/Needs";
import Products from "../Miltis/Products";
import RelatedPersons from "../Miltis/RelatedPersons";
import SocialSecurityNumber from "../Miltis/SocialSecurityNumber";
import SpouseJustification from "../Miltis/SpouseJustification";
import SubscriptionDone from "../Miltis/SubscriptionDone";
import Upsells from "../Miltis/Upsells";

const AdherentBirthDateWithTerritorial = (props) => (
  <AdherentBirthDate {...props} territorial={true} />
);
const ProductsWithTerritorial = (props) => (
  <Products {...props} territorial={true} />
);
const RelatedPersonsWithTerritorial = (props) => (
  <RelatedPersons {...props} territorial={true} />
);

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].ADHERENT_BIRTHDATE]:
    AdherentBirthDateWithTerritorial,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].PRODUCTS]:
    ProductsWithTerritorial,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].EFFECTIVE_DATE]:
    EffectiveDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].ADHERENT_TELECOMS]:
    AdherentTelecoms,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].RELATED_PERSONS]:
    RelatedPersonsWithTerritorial,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].ADHERENT_BANK_INFORMATION]:
    BankInformation,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].GENERATE_E_SIGN_DOCUMENTS]:
    GenerateESignDocuments,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].E_SIGN]: ElectronicSignature,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].JUSTIFICATIONS]:
    Justification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].SPOUSE_JUSTIFICATIONS]:
    SpouseJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].CHILDREN_JUSTIFICATIONS]:
    ChildrenJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].UPSELLS]: Upsells,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MILTIS].SUBSCRIPTION_DONE]:
    SubscriptionDone,
  default: Default,
};
export default Templates;
